import { TrendingDown, TrendingFlat, TrendingUp } from '@mui/icons-material';
import { Box, TableCell } from '@mui/material';
import { GridCellProps } from '@progress/kendo-react-grid';
import moment from 'moment';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { usePerformanceCellStyles } from './performanceCellStyles';

export const PerformanceCell = ({ dataItem, rowType }: GridCellProps) => {
  const sxStyles = usePerformanceCellStyles();
  const { performanceScore } = dataItem;
  const { t } = useTranslation();

  if (!performanceScore || rowType !== 'data') {
    return null;
  }

  const performanceStatusIndicator = (trend?: number) => {
    if (trend === 1) {
      return <TrendingUp sx={sxStyles.trendingUpIcon} />;
    }

    if (trend === 0) {
      return <TrendingFlat sx={sxStyles.trendingFlatIcon} />;
    }

    if (trend === -1) {
      return <TrendingDown color="error" />;
    }

    return undefined;
  };

  return (
    <TableCell sx={sxStyles.dataCell}>
      <Box>
        {performanceScore.score}
        {performanceStatusIndicator(performanceScore.trend)}
        <p>
          {t('sinceDate', {
            date: moment(performanceScore.reviewDate).format('L'),
          })}
        </p>
      </Box>
    </TableCell>
  );
};
